import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f1a674b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4f1a674b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1a674b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1a674b')) {
      api.createRecord('4f1a674b', component.options)
    } else {
      api.reload('4f1a674b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f1a674b&scoped=true", function () {
      api.rerender('4f1a674b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/tgOrderList/index.vue"
export default component.exports